import { render, staticRenderFns } from "./informacionFamiliar.vue?vue&type=template&id=159097ea"
import script from "./informacionFamiliar.vue?vue&type=script&lang=js"
export * from "./informacionFamiliar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports